import api from '../index'

export default {
  // 登录
  login: (data: {
    account: string
    password: string
  }) => api.post('user/login', data),

  // 获取权限
  permission: () => api.get('user/permission'),

  // 修改密码
  passwordEdit: (data: {
    password: string
    newPassword: string
  }) => api.post('user/password/edit', data),

  // 获取是否为超级管理员
  isAdmin: () => api.get('/user/judge-super-admin'),

  // 获取用户角色信息
  roleInfo: () => api.get('/user/current-permissions'),
}
